(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nzr-content-protection"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.NzrContentProtectionInitialized || window.Shopify?.designMode) return;

    const mainContent = document.getElementById('MainContent');
    const notice = document.getElementById('NzrContentProtectionNotice');
    if (!mainContent || !notice) return;

    window.NzrContentProtectionInitialized = true;
    document.documentElement.classList.add('nzr-content-protection-enabled');

    const editableSelector =
      "input, textarea, select, option, [contenteditable='true'], [role='textbox'], [data-nzr-copy-allowed]";
    const protectedMediaSelector = 'img, picture, video, canvas';
    let noticeTimer;

    const elementFromNode = (node) => {
      if (node instanceof Element) return node;
      return node?.parentElement || null;
    };

    const isEditable = (node) => elementFromNode(node)?.closest(editableSelector) !== null;

    const isInsideMainContent = (node) => {
      const element = elementFromNode(node);
      return element === mainContent || mainContent.contains(element);
    };

    const selectionIsProtected = () => {
      const selection = window.getSelection();
      if (!selection || selection.isCollapsed || selection.rangeCount === 0) return false;

      const range = selection.getRangeAt(0);
      return (
        isInsideMainContent(range.commonAncestorContainer) ||
        isInsideMainContent(selection.anchorNode) ||
        isInsideMainContent(selection.focusNode)
      );
    };

    const showNotice = () => {
      window.clearTimeout(noticeTimer);
      notice.hidden = false;

      window.requestAnimationFrame(() => {
        notice.classList.add('is-visible');
      });

      noticeTimer = window.setTimeout(() => {
        notice.classList.remove('is-visible');
        window.setTimeout(() => {
          notice.hidden = true;
        }, 190);
      }, 2600);
    };

    const disableImageDragging = (root) => {
      if (!(root instanceof Element || root instanceof Document)) return;

      if (root instanceof HTMLImageElement) root.draggable = false;
      root.querySelectorAll?.('img').forEach((image) => {
        image.draggable = false;
      });
    };

    disableImageDragging(document);

    const mediaObserver = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        mutation.addedNodes.forEach((node) => disableImageDragging(node));
      }
    });
    mediaObserver.observe(document.body, { childList: true, subtree: true });

    document.addEventListener(
      'contextmenu',
      (event) => {
        const target = elementFromNode(event.target);
        if (!target || isEditable(target)) return;

        const protectedMedia = target.closest(protectedMediaSelector);
        if (protectedMedia) {
          event.preventDefault();
          showNotice();
          return;
        }

        if (!isInsideMainContent(target) || target.closest('a, button, summary, [role="button"], [role="link"]')) return;

        event.preventDefault();
        showNotice();
      },
      { capture: true }
    );

    document.addEventListener(
      'dragstart',
      (event) => {
        const target = elementFromNode(event.target);
        if (!target?.closest(protectedMediaSelector) || isEditable(target)) return;

        event.preventDefault();
        showNotice();
      },
      { capture: true }
    );

    document.addEventListener(
      'copy',
      (event) => {
        if (isEditable(event.target) || !selectionIsProtected()) return;

        event.preventDefault();
        showNotice();
      },
      { capture: true }
    );
  })();
  } catch(e) { console.error(e); }
})();

})();
